import { Box } from "@chakra-ui/react";

const QuickActionsContainer = ({ children }: { children: JSX.Element }) => (
  <Box mb="4" bg="gray.50" px="4" py="4" rounded="lg" border="1px" borderColor="brand.200">
    {children}
  </Box>
);

export default QuickActionsContainer;
